import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import { STR_ADD, STR_APPLY_VAT_AUTOMATICALLY, STR_AVAILABLE_QUANTITY, STR_BUSINESS_NAME, STR_BUSINESS_TYPE, STR_CLIENT, STR_CLIENT_LEVEL, STR_CLIENT_SEARCH_HELPER_TEXT, STR_COMPANY, STR_COMPLETED_SALE, STR_COMPLETED_SALE_HELPER_TEXT, STR_CONTACT_US, STR_CUSTOMER, STR_DESCRIPTON, STR_EMAIL_ADDRESS, STR_ESTIMATE_SALE, STR_ESTIMATE_SALE_HELPER_TEXT, STR_EXISTING_CLIENT, STR_GET_FREE_TRIAL, STR_INVALID_BUSINESS_NAME, STR_INVALID_NAME, STR_INVALID_NAME_2, STR_INVALID_PHONE_2, STR_INVALID_TITLE, STR_INVALID_UNIT, STR_INVALID_UNIT_PRICE, STR_ITEM_TYPE, STR_ITEMS, STR_LEAD, STR_NAME, STR_NEW_CLIENT, STR_NO, STR_NO_RECORD, STR_NUMERIC_VALUE_IS_REQUIRED, STR_OPTIONAL, STR_PHONE_NUMBER, STR_PHYSICAL_ADDRESS, STR_PLEASE_ADD_ITEMS, STR_POBOX, STR_PRODUCT_CODE, STR_QUICKLY_REGISTER_CLIENT, STR_RECORD_SALE, STR_REGISTER_BUSINESS, STR_REGISTER_CLIENT, STR_REGISTER_STOCK_ITEM, STR_REGISTER_VENDOR, STR_SALE_LEVEL, STR_SEARCH_HERE, STR_SOLE_PROPRIETOR, STR_SUBMIT, STR_SUCCESS, STR_TIN, STR_UNIT, STR_UNIT_PRICE, STR_VRN, STR_WEBSITE_URL, STR_WHATSAPP_NUMBER, STR_WITH_COUNTRY_CODE, STR_YES } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdAdd, MdCall, MdEmail, MdWarning } from "react-icons/md";
import NapaAddressPicker from "../ones/NapaAddressPicker";
import OneClient from "../ones/OneClient";
import { TiWarning } from "react-icons/ti";


export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);

  const [level, setLevel] = useState('completed'); //or estimate
  const [clientUuid, setClientUuid] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  const [clientType, setClientType] = useState('existing');
  const [clientFilter, setClientFilter] = useState('');
  const [items, setItems] = useState([]);
  const [applyVatAutomatically, setApplyVatAutomatically] = useState('yes');

  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      appContext.getAllClients(),
    ])
    setReady(true);
  }

  function resetForm() {
    
  }

  async function submit() {
    
  }

  function addItem() {
    
    const itemTemp = {
      itemType: 'custom', //custom, stock, non-stock, vat
      stockItemUuid: '',
      stockItemCode: '',
      nonStockItemUuid: '',
      nonStockItemCode: '',
      title: '',
      unit: '',
      unitPrice: 0,
      quantity: 0,
      subTotal: 0,

    };

    setItems(_prev => {
      const _new = [..._prev];

      _new.push(itemTemp);

      return _new;
    })
    
  }

  function editItem({index, field, value, stockItem = null, nonStockItem = null}) {
    setItems(_prev => {
      const _new = [..._prev];

      if(
        field === 'unitPrice' ||
        field === 'quantity'
      ) {
        if(!isNaN(Number(value))) {
          _new[index][field] = Number(value);

          _new[index].subTotal = Number(_new[index].unitPrice) * Number(_new[index].quantity);
        } else {
          appContext.tellError(STR_NUMERIC_VALUE_IS_REQUIRED[appContext.language]);
        }
      } else {
        _new[index][field] = value;
      }

      return _new;
    })
  }

  function deleteItem(index) {
    setItems(_prev => {
      const _new = [..._prev];

      _new.splice(index, 1);

      return _new;
    })
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    if(clientType === 'new') {
      setSelectedClient(null);
      setClientUuid('');
    }
  }, [ clientType ])

  useEffect(() => {
    if(selectedClient) {
      setClientUuid(selectedClient.uuid)
    }
  }, [ selectedClient ])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [ loading ])

  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12">
              <h6 className="main-section-title">
                {STR_RECORD_SALE[appContext.language]}
              </h6>
            </div>

            
            <div className="col-md-12 mt-3 mb-3">
              <label className="form-label">{STR_SALE_LEVEL[appContext.language]}</label>
              <div className="row">
                <div className="col-6">
                  <button
                    className={(level === 'completed') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
                    style={{
                      height: '100px',
                    }}
                    onClick={() => {
                      setLevel('completed')
                    }}
                  >
                    {STR_COMPLETED_SALE[appContext.language]}
                  </button>

                  <div className="form-text">{STR_COMPLETED_SALE_HELPER_TEXT[appContext.language]}</div>
                </div>

                <div className="col-6">
                  <button
                    className={(level === 'estimate') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
                    style={{
                      height: '100px',
                    }}
                    onClick={() => {
                      setLevel('estimate')
                    }}
                  >
                    {STR_ESTIMATE_SALE[appContext.language]}
                  </button>

                  <div className="form-text">{STR_ESTIMATE_SALE_HELPER_TEXT[appContext.language]}</div>
                </div>
              </div>
            
            </div>

            <div className="col-md-12 mt-3 mb-3">
              <label className="form-label">{STR_CLIENT[appContext.language]}</label>
              
              <div className="row">
                <div className="col-6">
                  <button
                    className={(clientType === 'existing') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
                    style={{
                      height: '50px',
                    }}
                    onClick={() => {
                      setClientType('existing');
                    }}
                  >
                    {STR_EXISTING_CLIENT[appContext.language]}
                  </button>

                </div>

                <div className="col-6">
                  <button
                    className={(clientType === 'new') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
                    style={{
                      height: '50px',
                    }}
                    onClick={() => {
                      setClientType('new');
                    }}
                  >
                    {STR_NEW_CLIENT[appContext.language]}
                  </button>

                </div>

                {
                  (clientType === 'existing') ?
                  <div className="col-md-12 mt-2 mb-2">
                    <div className="card">
                      <div className="card-body">
                        {
                          (selectedClient) ?
                          <OneClient data={selectedClient} isClickable={false}/>
                          :""
                        }
                        <div className="mt-4 mb-4">
                          <input
                            className="form-control"
                            placeholder={STR_SEARCH_HERE[appContext.language]}
                            value={clientFilter}
                            onChange={(e) => setClientFilter(e.target.value)}
                          />
                          <div className="form-text">
                            {STR_CLIENT_SEARCH_HELPER_TEXT[appContext.language]}
                          </div>
                        </div>

                        {
                          (appContext.allClients && appContext.allClients.length > 0) ?
                          (
                            () => {
                              if(clientFilter && clientFilter.trim().length > 0) {
                                //apply filter first
                                const _filtered = appContext.allClients.filter((item, i) => {
                                  return (
                                    String(item.name).toLowerCase().indexOf(String(clientFilter).toLowerCase()) > -1 ||
                                    String(item.phone).toLowerCase().indexOf(String(clientFilter).toLowerCase()) > -1 ||
                                    String(item.whatsAppNumber).toLowerCase().indexOf(String(clientFilter).toLowerCase()) > -1 ||
                                    String(item.tin).toLowerCase().indexOf(String(clientFilter).toLowerCase()) > -1 ||
                                    String(item.vrn).toLowerCase().indexOf(String(clientFilter).toLowerCase()) > -1 ||
                                    String(item.email).toLowerCase().indexOf(String(clientFilter).toLowerCase()) > -1
                                  ) 
                                });

                                return _filtered;
                              } else {
                                return appContext.allClients;
                              }
                            }
                          )().slice(0, 4).map((item, i) => {
                            return (
                              <div
                                key={i}
                                style={{
                                  borderBottom: "1px solid gray",
                                  padding: '5px',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setSelectedClient(item);
                                }}
                                className={(selectedClient && selectedClient.uuid === item.uuid) ? 'bg-primary' : ''}
                              >
                                <h6
                                  style={{
                                    fontSize: "14px"
                                  }}
                                  className="font-semi-bold"
                                >
                                  {item.name}
                                </h6>
                                <h6
                                  style={{
                                    fontSize: "12px"
                                  }}
                                  className="font-light"
                                >
                                  Phone: {(item.phone || 'N/A')}
                                </h6>
                                <h6
                                  style={{
                                    fontSize: "12px"
                                  }}
                                  className="font-light"
                                >
                                  TIN: {(item.tin || 'N/A')}
                                </h6>
                              </div>
                            )
                          })
                          :
                          <h6>{STR_NO_RECORD[appContext.language]}</h6>
                        }
                      </div>
                    </div>
                  </div>
                  :""
                }

                {
                  (clientType === 'new') ?
                  <div className="col-md-12 mt-2 mb-2">
                    <div className="card">
                      <div className="card-body text-center">
                        <h6
                          style={{
                            fontSize: "20px",
                            padding: "20px",
                          }}

                          className="font-light mt-3 mb-3"
                        >
                          {STR_QUICKLY_REGISTER_CLIENT[appContext.language]}
                        </h6> 

                        <button
                          className="btn btn-padded btn-rounded btn-outline-secondary"
                          onClick={() => {
                            appContext.navTo({
                              item: 'side-view',
                              subItem: 'register-client',
                            })
                          }}
                        >
                          {STR_REGISTER_CLIENT[appContext.language]}
                        </button>
                      </div>
                    </div>
                  </div>
                  :""
                }
              </div>

            </div>

            <div className="col-md-12 mt-3 mb-3">
              <label className="form-label">{STR_APPLY_VAT_AUTOMATICALLY[appContext.language]}</label>
              <div className="row">
                <div className="col-6">
                  <button
                    className={(applyVatAutomatically === 'yes') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
                    style={{
                      height: '40px',
                    }}
                    onClick={() => {
                      setApplyVatAutomatically('yes')
                    }}
                  >
                    {STR_YES[appContext.language]}
                  </button>

                </div>

                <div className="col-6">
                  <button
                    className={(applyVatAutomatically === 'no') ? "btn btn-block btn-primary" : "btn btn-block btn-outline-primary"}
                    style={{
                      height: '40px',
                    }}
                    onClick={() => {
                      setApplyVatAutomatically('no')
                    }}
                  >
                    {STR_NO[appContext.language]}
                  </button>

                </div>
              </div>
            
            </div>

            <div className="col-md-12 mt-3 mb-3">
              <label className="form-label">{STR_ITEMS[appContext.language]}</label>
              <div
                style={{
                  width: "100%",
                  overflowY: "scroll",
                }}
              >
                <div className="card">
                  <div className="card-body">
                    {
                      (items && items.length > 0) ?
                      items.map((item,i) => {
                        return (
                          <div key={i} className="card">
                            <div className="card-body">
                              <div className="row">

                                <div className="col-md-4 col-12 mt-3 mb-3">
                                  <label className="form-label">{STR_ITEM_TYPE[appContext.language]}</label>
                                  <select
                                    className="form-control"
                                    value={item.itemType}
                                    onChange={(e) => {
                                      editItem({
                                        index: i,
                                        field: 'itemType',
                                        value: e.target.value,
                                        stockItem: null,
                                        nonStockItem: null,
                                      })
                                    }}
                                  >
                                    <option value='' ></option>
                                    <option></option>
                                  </select>
                                </div>


                              </div>
                            </div>
                          </div>
                        )
                      })
                      :
                      <h6
                        style={{
                          fontSize: "14px",
                          padding: "20px",
                        }}
                        className="text-center"
                      >
                        <TiWarning size={32} className="text-danger"/>
                        <br/>
                        {STR_PLEASE_ADD_ITEMS[appContext.language]}
                      </h6>
                    }

                    <div className="text-end">
                      <hr/>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={addItem}
                      >
                        <MdAdd size={24}/> {STR_ADD[appContext.language]}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-md-12 mt-3 mb-5">
              <button
                className="btn btn-block btn-padded btn-rounded btn-secondary"
                onClick={submit}
              >
                {STR_SUBMIT[appContext.language]}
              </button>
            </div>

          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}